import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import {
  authLogin as actionAuthLogin,
  authSignUp as actionAuthSignUp,
} from '../../../redux/auth/actions';
import {
  selectSignUpType,
  selectSignUpInvite,
} from '../../../redux/auth/selectors';

import containerStyles from '../styles.scss';

import InfoFormBusiness from './InfoFormBusiness';
import SignUpBanner from '../components/SignUpBanner';
import SignUpContainer from '../components/SignUpContainer';

class KnockKnockInfoForm extends Component {
  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
  };

  handleSendRequest = data => {};

  render() {
    const { location } = this.props;
    const isBusiness = location.pathname.includes('business');

    return (
      <SignUpContainer>
        <div className={containerStyles.container}>
          <div
            style={{
              flexDirection: 'column',
              display: 'flex',
              maxWidth: 600,
              minHeight: 30,
            }}
          >
            <>
              <SignUpBanner location={location} isHomeowner={!isBusiness} />
              <InfoFormBusiness
                isBusiness={isBusiness}
                navigateNext={this.handleSendRequest}
              />
            </>
          </div>
        </div>
      </SignUpContainer>
    );
  }
}

const mapStateToProps = state => ({
  type: selectSignUpType(state),
  inviteData: selectSignUpInvite(state),
});

const bindAction = {
  authLogin: actionAuthLogin,
  authSignUp: actionAuthSignUp,
};

export default withRouter(
  connect(
    mapStateToProps,
    bindAction,
  )(KnockKnockInfoForm),
);
